import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingParamService } from '../Services/routing-param.service';
import { User } from '../Services/WOWApi.Service';
import { CustomServiceService } from '../Services/custom-service.service';
import { CommonService } from '../Services/common.service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy {
  isfooterBarOpen = false;
  isMoblileView = false;
  loggedUser: User;
  isHost:boolean = false;
  isOwner: boolean = false;
  subscription: Subscription;
  isShowLMenu = false;
  isLoggedIn = false;
  private footerHovered = false;
  private hideTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly collapsedOffset = '12px';
  private readonly revealedOffset = '120px';
  constructor(
    private router: Router,
    private routingParam: RoutingParamService, private customServices:CustomServiceService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.loggedUser = this.customServices.GetLoggedInUser();
    if(this.loggedUser !== undefined && this.loggedUser !=null)
    {
      this.isHost = this.loggedUser.isHost;
      this.isOwner = this.loggedUser.isOwner;
      this.isLoggedIn = true;
    }
    this.subscription = this.commonService.isMobileView.subscribe(res => {
      if (res === true) {
        this.isMoblileView = true;
        this.isfooterBarOpen = true;
        this.setFooterOffset('70px');
        this.subscription = this.commonService.isFooterCollapsible.subscribe(val => {
          if (val === true) {
            this.isfooterBarOpen = false;
          } else {
            this.isfooterBarOpen = true;
          }
        })
      } else {
        this.isMoblileView = false;
        this.isfooterBarOpen = false;
        this.setFooterOffset(this.collapsedOffset);
      }
    })
  }

  ngOnDestroy(): void {
    this.clearHideTimer();
    this.subscription.unsubscribe();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (this.isMoblileView) {
      return;
    }
    const fromBottom = window.innerHeight - event.clientY;
    if (fromBottom <= 36) {
      this.revealFooter();
      return;
    }
    if (!this.footerHovered && fromBottom > 88) {
      this.scheduleHide();
    }
  }

  onFooterEnter(): void {
    this.footerHovered = true;
    this.revealFooter();
  }

  onFooterLeave(): void {
    this.footerHovered = false;
    this.scheduleHide();
  }

  private revealFooter(): void {
    this.clearHideTimer();
    this.isfooterBarOpen = true;
    this.setFooterOffset(this.revealedOffset);
  }

  private scheduleHide(): void {
    this.clearHideTimer();
    this.hideTimer = setTimeout(() => {
      if (!this.footerHovered && !this.isMoblileView) {
        this.isfooterBarOpen = false;
        this.setFooterOffset(this.collapsedOffset);
      }
    }, 280);
  }

  private clearHideTimer(): void {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  private setFooterOffset(value: string): void {
    document.documentElement.style.setProperty('--app-footer-offset', value);
  }
  
  Navigate(route: string) {
    switch (route) {
      case 'SignUpHost':
        this.routingParam.setRoutingParam({ path: 'SignUpHost' });
        break;
      case 'HostPortal':
        this.routingParam.setRoutingParam({ path: 'HostPortal' });
        break;
      case 'MyAccount':
        this.routingParam.setRoutingParam({ path: 'MyAccount' });
        break;
      case 'SignUpForEmail':
        this.routingParam.setRoutingParam({ path: 'MyAccount/true'  });
        break;
    }
    this.router.navigate(['Login']);
  }

  toggleNavbar() {
    if (this.isfooterBarOpen) {
      this.commonService.setFooterCommapsible(true);
    } else {
      this.commonService.setFooterCommapsible(false);
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 200)
    }
  }

  onOpenLink() {
    if (this.isMoblileView) {
      setTimeout(() => {
        this.isfooterBarOpen = false;
        this.isShowLMenu = false;
      }, 100);
    }
  }

  goToTop() {
    window.scrollTo(0, 0);
  }

  onHoverOnList() {
    this.isShowLMenu = !this.isShowLMenu;
  }

}
